interface BrandWordmarkProps {
  height?: number;
  color?: string;
}

/**
 * FOUNDATION wordmark. Paths inlined from `src/assets/brand/logo-wordmark.svg`.
 * Width is computed from the original aspect ratio (1681 / 153 ≈ 10.99) so callers
 * only need to pass a target height (e.g. 12px in the sidebar).
 */
export function BrandWordmark({ height = 14, color = "currentColor" }: BrandWordmarkProps) {
  const aspect = 1681 / 153;
  const width = Math.round(height * aspect);
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="119 463 1681 153"
      width={width}
      height={height}
      fill={color}
      role="img"
      aria-label="Foundation"
      style={{
        display: "block",
        flexShrink: 0,
        filter: "var(--brand-filter, none)",
      }}
    >
      <path d="M260.6,469.2v21.1h-103.3v38.6h90.7v20.1h-90.7v61.8h-35.5v-141.5h138.8Z" />
      <path d="M367.9,465.9c28.3,0,51.4,6.9,69.1,20.6,17.7,13.7,26.6,31.6,26.6,53.6s-8.9,39.9-26.8,53.6c-17.8,13.7-41,20.6-69.6,20.6s-52-6.8-69.7-20.5c-17.7-13.6-26.6-31.5-26.6-53.7s8.7-39.2,26-53.2c17.4-14,41-21,70.8-21ZM367.3,486.7c-18.4,0-33.1,4.8-44.2,14.4-11.1,9.6-16.6,22.4-16.6,38.5s5.5,29.5,16.5,39.2c11,9.7,26,14.5,44.9,14.5s32.8-4.9,43.8-14.6c11-9.7,16.5-22.7,16.5-38.9s-5.5-29.1-16.5-38.7c-11-9.6-25.8-14.4-44.4-14.4Z" />
      <path d="M649.3,469.2v86.7c0,38.4-27.2,57.6-81.7,57.6s-49.2-4.8-62.7-14.3c-13.4-9.5-20.1-24.1-20.1-43.7v-86.3h35.2v91.2c0,21.7,16.1,32.6,48.2,32.6s17.8-.9,24.1-2.8c6.3-1.9,10.9-4.7,13.9-8.5,3-3.8,5.1-8,6.2-12.4,1.1-4.4,1.7-10,1.7-16.6v-83.5h35.2Z" />
      <path d="M835.3,469.2v141.5h-36.3l-93.5-104.2v104.2h-33.2v-141.5h36.9l92.4,104.4v-104.4h33.8Z" />
      <path d="M859.2,469.2h76.3c13.9,0,26.1,1,36.6,3.1,10.5,2.1,20.2,5.9,29,11.4,19.7,12.5,29.6,30.4,29.6,53.9s-9.4,44.2-28.2,57.4c-8.3,5.8-17.2,9.9-26.9,12.2-9.7,2.3-22.4,3.5-38.2,3.5h-78.3v-141.5ZM894.1,490.3v99.6h41.4c22,0,37.5-4.5,46.5-13.5,9-9,13.5-21.5,13.5-37.6s-5.1-27.1-15.2-35.7c-10.1-8.5-25.8-12.8-47-12.8h-39.1Z" />
      <path d="M1137,469l77.4,141.7h-37.7l-19.1-37.6h-79.4l-19.7,37.6h-36.3l77.4-141.7h37.5ZM1148.2,554.5l-29.8-59.6-31.3,59.6h61.1Z" />
      <path d="M1342.3,469.2v21.5h-63.9v120.1h-35.2v-120.1h-63.9v-21.5h163Z" />
      <path d="M1397.9,469.2v141.5h-35.5v-141.5h35.5Z" />
      <path d="M1518.6,465.9c28.3,0,51.4,6.9,69.1,20.6,17.7,13.7,26.6,31.6,26.6,53.6s-8.9,39.9-26.7,53.6c-17.8,13.7-41,20.6-69.6,20.6s-52-6.8-69.7-20.5c-17.7-13.6-26.6-31.5-26.6-53.7s8.7-39.2,26-53.2c17.4-14,41-21,70.8-21ZM1518.1,486.7c-18.4,0-33.1,4.8-44.2,14.4-11.1,9.6-16.6,22.4-16.6,38.5s5.5,29.5,16.5,39.2c11,9.7,26,14.5,44.9,14.5s32.8-4.9,43.8-14.6c11-9.7,16.5-22.7,16.5-38.9s-5.5-29.1-16.5-38.7c-11-9.6-25.8-14.4-44.4-14.4Z" />
      <path d="M1798.2,469.2v141.5h-36.3l-93.5-104.2v104.2h-33.2v-141.5h36.9l92.4,104.4v-104.4h33.8Z" />
    </svg>
  );
}
